import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringReplace',
})
export class StringReplacePipe implements PipeTransform {
  transform(
    text: string,
    textToReplace: string,
    textToReplaceWith: string | number
  ): string {
    return text.replace(textToReplace, '' + textToReplaceWith);
  }
}
